module.exports = __webpack_public_path__ + "img/3.09a74262.jpg";